var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgreements(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.7,
    height: 24.94,
    viewBox: "0 0 14.7 24.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0a0a0a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-171.225 -6.06)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.775 2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(176 13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M142.887,234.815h-3.335a2.726,2.726,0,0,0-2.723,2.723v5.513a.545.545,0,0,0,.545.545h7.691a.545.545,0,0,0,.545-.545v-5.513A2.726,2.726,0,0,0,142.887,234.815Z",
    transform: "translate(-136.829 -234.815)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.116 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M170.389,38.84a3.274,3.274,0,1,0,3.274,3.275A3.278,3.278,0,0,0,170.389,38.84Z",
    transform: "translate(-167.114 -38.84)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172 6.06)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.519,137.8h9.3a.286.286,0,1,1,0,.571h-9.3a.286.286,0,1,1,0-.571Z",
    transform: "translate(-80.204 -132.579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.167,86.128H82.519a.286.286,0,1,1,0-.571h4.648a.286.286,0,0,1,0,.571Z",
    transform: "translate(-75.556 -82.313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.519,184.1h9.3a.286.286,0,1,1,0,.571h-9.3a.286.286,0,1,1,0-.571Z",
    transform: "translate(-80.204 -177.116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.223,17.429H41.2a.887.887,0,0,0,.886-.886V1.457A.887.887,0,0,0,41.2.571H32.627a.611.611,0,0,0-.082.006V2.358a1.458,1.458,0,0,1-1.457,1.457H29.307A.605.605,0,0,0,29.3,3.9V8.76a.286.286,0,0,1-.571,0V3.9a1.165,1.165,0,0,1,.344-.829L31.8.344A1.165,1.165,0,0,1,32.627,0H41.2a1.458,1.458,0,0,1,1.457,1.457V16.543A1.458,1.458,0,0,1,41.2,18H38.223a.286.286,0,1,1,0-.571ZM29.705,3.244h1.383a.887.887,0,0,0,.886-.886V.975Z",
    transform: "translate(-28.73 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreements);
export default __webpack_public_path__ + "static/media/agreements.abe8fceffeb935a0e51bcda163c01a46.svg";
export { ForwardRef as ReactComponent };